import {gql} from '@apollo/client';

export const AML_KYC_CONTACT_FRAGMENT = gql`
  fragment AmlKycContact on ContactType {
    id
    simplifiedName
    nationality
    dualNationality
    employmentStatus
    hubwiseOccupation
    hubwiseIndustry
    annualIncome
    retirementAge
    amlKycRequiredFields
    amlKycMissingFields
  }
`;

export const GET_AML_KYC_OPTIONS = gql`
  query AmlKycOptions($accountId: UUID!) {
    amlKycOptions(accountId: $accountId) {
      isEnabled
      nationalities {
        code
        label
      }
      employmentStatuses
      occupations
      industries
      notWorkingStatuses
    }
  }
`;

export const GET_CONTACT_AML_KYC = gql`
  query ContactAmlKyc($accountId: UUID!) {
    contacts(accountId: $accountId) {
      ...AmlKycContact
    }
  }
  ${AML_KYC_CONTACT_FRAGMENT}
`;

export const UPDATE_AML_KYC = gql`
  mutation UpdateAmlKyc(
    $accountId: UUID!
    $contactId: UUID!
    $nationality: String
    $dualNationality: String
    $employmentStatus: String
    $hubwiseOccupation: String
    $hubwiseIndustry: String
    $annualIncome: Decimal
    $retirementAge: Int
  ) {
    updateAmlKyc(
      accountId: $accountId
      contactId: $contactId
      nationality: $nationality
      dualNationality: $dualNationality
      employmentStatus: $employmentStatus
      hubwiseOccupation: $hubwiseOccupation
      hubwiseIndustry: $hubwiseIndustry
      annualIncome: $annualIncome
      retirementAge: $retirementAge
    ) {
      ok
      errors
      contact {
        ...AmlKycContact
      }
    }
  }
  ${AML_KYC_CONTACT_FRAGMENT}
`;
